import React from 'react';
import { Image, T, Tooltip } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import styles from './BadgesRow.module.scss';
export const BadgesRow = ({ badges })=>{
    if (badges == undefined) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.badgesContainer
    }, badges.map((badge, index)=>/*#__PURE__*/ React.createElement(Badge, {
            key: index,
            image: badge.image,
            tooltipText: badge.tooltipText
        })));
};
const Badge = ({ image, tooltipText })=>{
    return /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: tooltipText
        }),
        position: "bottom"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.badgeImage,
        image: {
            src: image,
            alt: emptyTranslation
        }
    }));
};
